import React from "react";
import { MathOperatorChildrenType } from "../mathOperatorTypes";

/* The old `bg-gray-100` was unprefixed — a dead class that never painted, so
   the panel has always shown the ground behind it; kept transparent on purpose
   and given a real edge border. The stray top/left offsets were inert too
   (no `tw-absolute`) and are gone. */
const Wrapper = ({ children }: MathOperatorChildrenType) => {
  return <div className='tw-w-[330px] tw-h-[224px] tw-p-[10px] tw-border tw-rounded-sm tw-border-solid tw-border-edge'>{children}</div>;
};

export default Wrapper;